<template>
  <header class="clearfix mt0 header">
    <div class="col col-12">
      <div class="clearfix">
        <div class="max-width-4 mx-auto">
          <div class="clearfix height-140">
            <div class="images">
              <img src="../assets/harald-parainer-profil.png" alt="Psychologische Praxis- Mag. Harald Parrainer">
            </div>
            <div class="content">
              <div class="down">
                <h3 class="headline mb0 bold">Psychologische Praxis</h3>
                <h4 class="headline mt1 mb0 bold">Mag. Harald Parrainer</h4>
                <p class="mt1 mb0">Klinischer Psychologe. Gesundheitspsychologe.</p>
              </div>
            </div>
            <div class="images xs-hide">
              <img src="../assets/harald-parainer-praxis-key.png" alt="Psychologische Praxis- Mag. Harald Parrainer">
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  export default {
    name: 'app-header'
  }
</script>

<style lang="scss">
@import "../assets/scss/variables";

.header {
  background-color: white;

  .bold {
    font-weight: 600;
  }

  .height-140 {
    height: 135px;
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    overflow: hidden;

    display: flex;
    justify-content: end;
    vertical-align: bottom;

    .images {
      flex-grow: unset;

      img {
        width: auto;
        height: 145px;
      }
    }

    .content {
      flex-grow: 1;
      display:flex;
      flex-direction:row;
      flex-wrap:wrap;

      background: #ffffff;
      background: linear-gradient(to right,  #ffffff 0%, #fefefe 45%, #f0f0f3 45%, #f0f0f3 55%, #ffffff 55%,#ffffff 100%);

      .headline {
        color: #000000;
      }

      .down {
        text-align: center;
        flex-grow: 1;
        align-self:flex-end;
        padding-bottom: 0.5rem;
      }
    }
  }

  @media screen and (max-width: $break-md) {
    .height-140 {
      height: 140px;

      .content {
        padding-top: 0.3rem;
        margin-bottom: 0.3rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue